import { getFontSize, useTheme } from "@rentiohq/web-shared-next/dist/themes";
import { EFontSizes } from "@rentiohq/web-shared-next/dist/themes/types";

export const ContactCardStyles = () => {
  const theme = useTheme();

  return {
    wrapper: {
      p: 3,
      borderRadius: "8px",
      border: `1px solid ${theme.palette.grey[200]}`,
      minWidth: "330px",
    },
    content: {
      avatar: {
        width: "72px",
        height: "72px",
        background: "#E3E8EF",

        svg: {
          color: "white",
        },
      },
      label: {
        fontSize: getFontSize(EFontSizes.ExtraSmall),
      },
      value: {
        color: theme.palette.grey[900],
      },
    },
  };
};
